// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2oFq2","header":"PatientBlock_header__3ahAl","label":"PatientBlock_label__3p34b","option":"PatientBlock_option__2mpAu"};